import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import TopAdd from "components/TopAdd";
import Topnav from "components/Topnav";
import RightAdd from "components/RightAdd";

import Player from "components/definitions/roles-forms/Player";
import { registerAccount } from "services/auth_service";

import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { getAccountByUserId } from "services/user_service";

import { putAccount, getAccount } from "services/account_service";

function App() {
  const validationSchema = Yup.object().shape({
    email: Yup.string().required("Email is required").email("Email is invalid"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const { t } = useTranslation();
  const navigate = useNavigate();

  const { teamId } = useParams();
  const { playerId } = useParams();

  const [roleDetails, setRoleDetails] = useState({});

  useEffect(() => {
    async function fetchData() {
      if (!playerId) return;

      let account = await getAccount(playerId);

      setValue("name", account.attributes.name);
      setValue("email", account.attributes.users.data[0].attributes.email);

      setRoleDetails({
        age: account.attributes.age,
        height: account.attributes.height,
        position: account.attributes.position,
        date_of_birth: account.attributes.date_of_birth,
        history: account.attributes.team_histories.data,
      });
    }

    fetchData();
  }, []);

  const submitForm = async (data) => {
    try {
      let jogadorId = playerId;

      console.log("🚀 ~ submitForm ~ roleDetails:", roleDetails);
      if (!roleDetails.position || roleDetails.position.length === 0) {
        toast.error("Por favor preencha a posição do jogador");
        return;
      }

      if (
        !roleDetails.date_of_birth ||
        roleDetails.date_of_birth === "" ||
        roleDetails.date_of_birth === "Invalid date"
      ) {
        toast.error("Por favor preencha a data de nascimento do jogador");
        return;
      }

      if (!playerId) {
        // if player id is not defined it means that the player already exists
        let respRegister = await registerAccount({
          ...data,
          teams: [+teamId],
          role: "Jogador",
          password: "fazfaz1234",
          repeatPass: "fazfaz1234",
        });

        jogadorId = respRegister.data.user.id;
      }

      let account = await getAccountByUserId(jogadorId);

      await putAccount(account.id, {
        ...roleDetails,
        role: "Jogador",
        team: teamId,
      });

      toast.success(
        "Jogador foi adicionado com sucesso. Foi enviado um email para o email registado."
      );
      navigate(`/equipas/${teamId}`);
    } catch (exception) {
      console.log("Exception: ", exception);
    }
  };

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
        <div className="conteudo">
        <TopAdd></TopAdd>
        <div style={{"display": "flex"}}>
          <section className="section dashboard">
            <nav className="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <Link to={"/equipas"}>Plantel</Link>/ Jogadores / Detalhe
              </ul>
            </nav>

            <div className="geral">
              <div className="hero is-footsolution">
                <div className="columns">
                  <div className="column">
                    <h1 className="title is-3">
                      {!playerId ? "Novo Jogador" : "Detalhe jogador"}
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            <div className="columns">
              <div className="column">
                <form onSubmit={handleSubmit((data) => submitForm(data))}>
                  <div className="block">
                    <div className="field">
                      <label className="label">Email *</label>
                      <p className="control">
                        <input
                          className={`input ${
                            errors.email ? "is-invalid" : ""
                          }`}
                          type="text"
                          {...register("email", {
                            required: true,
                          })}
                          disabled={!!playerId}
                          placeholder="exemplo@mail.com"
                        />
                      </p>
                    </div>

                    <div className="field">
                      <label className="label">Nome *</label>
                      <p className="control">
                        <input
                          className="input"
                          type="text"
                          {...register("name", {
                            required: true,
                            minLength: 5,
                          })}
                          disabled={!!playerId}
                          placeholder="Tiago Santos"
                        />
                      </p>
                    </div>
                  </div>
                  <Player
                    setRoleDetails={setRoleDetails}
                    roleDetails={roleDetails}
                    isReadOnly={!!playerId}
                  ></Player>
                  {!playerId && (
                    <button className="button is-link is-footsolution">
                      {t("send")}
                    </button>
                  )}
                </form>
                * Campos obrigatórios
                <p>
                  Quando entrar na plataforma o utilizador poderá alterar os
                  dados preenchidos neste formulário.
                </p>
              </div>
            </div>
          </section>
          <RightAdd></RightAdd>
         </div>
        </div>
      </div>
    </div>
  );
}

export default App;
